@if (showLog$ | async) {
  <div>
    <ion-fab vertical="bottom" horizontal="end" slot="fixed" [ngClass]="{ open: isOpen() }">
      <ion-fab-button (click)="toggle()">
        <ion-icon [name]="isOpen() ? 'arrow-down-circle' : 'arrow-up-circle'"></ion-icon>
      </ion-fab-button>
    </ion-fab>
    <ion-content #GpsLogPanel class="gpsLogPanel" [ngClass]="{ open: isOpen(), tracking: isTracking() }">
      @for (item of geoPositionLog(); track item) {
        <div>
          {{ timestampToString(item.timestamp) }} -
          @if (item.status !== "PositionUpdate") {
            <span>&nbsp;{{ item.status }}</span>
          }
          @if (item.status === "PositionUpdate") {
            <span>
              @if (item.pos) {
                <span
                  >&nbsp; {{ item.pos.coords.latitude | number: ".5" }}&deg;{{
                    "MAP_CENTER_INFO.NORTH_SHORT" | translate
                  }}, {{ item.pos.coords.longitude | number: ".5" }}&deg;{{ "MAP_CENTER_INFO.EAST_SHORT" | translate }},
                  {{ item.pos.coords.accuracy | number: "1.0-0" }}m
                </span>
              } @else {
                Empty
              }
            </span>
          }
          @if (item.status === "PositionError") {
            <span> &nbsp;{{ item.err ? getErrorCodeOrMessage(item.err) : "" }} </span>
          }
          @if (item.highAccuracyEnabled) {
            <span>&nbsp;(H)</span>
          }
        </div>
      }
    </ion-content>
  </div>
}
